// /**
//  * skus -CSV
//  */

// React
import React from 'react';
import {CSVLink} from 'react-csv';
import {SkuInventory} from '../../warehouses/interfaces';
import {Button} from '@material-ui/core';
import jMoment from 'moment-jalaali';
import RonadIcons from '../../../components/iconComponent';

type Props = {
  data: SkuInventory[];
  handleCreateCSV: () => void;
  loading: boolean;
};

function CardIndexCsv({data, handleCreateCSV, loading}: Props) {
  const flattData = (data: any) => {
    const newData = data.map(el => {
      let features = ''
      if(el.featureValues) {
        for (let i = 0; i <= 2 && el.featureValues[i]; i++) {
          features = features.concat(
            ' - ',
            el.featureValues[i].featureName,
            ' : ',
            el.featureValues[i].valueName
          );
        }
      }

      return {
        ...el,
        featureValues: features,
        enterDate: el.enterDate && jMoment(el.enterDate, 'YYYY/MM/DD').locale('fa').format('jYYYY/jMM/jDD'),
        updated: el.updated && jMoment(el.updated, 'YYYY/MM/DD').locale('fa').format('jYYYY/jMM/jDD')
      };
    })
    return newData
  };

  return (
    data?.length > 0 ? (
      <CSVLink
        data={flattData(data)}
        filename="skus.csv"
        style={{
          backgroundColor: '#DFA01F',
          padding: '10px',
          color: '#fff',
          marginLeft: '5px',
          textDecoration: 'none',
        }}
      >
        دانلود CSV
      </CSVLink>
    ) : (
      <Button
        style={{margin: '0 5px'}}
        variant="contained"
        color="primary"
        startIcon={<RonadIcons name='tableArrowUp' size={1} />}
        onClick={handleCreateCSV}
        disabled={loading}
      >
        ایجاد فایل CSV
      </Button>
    )
  );
}

export default CardIndexCsv;
